import { render, staticRenderFns } from "./_base-multi-select.vue?vue&type=template&id=16469d78"
import script from "./_base-multi-select.vue?vue&type=script&lang=js"
export * from "./_base-multi-select.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./_base-multi-select.vue?vue&type=style&index=1&id=16469d78&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports